<p *ngIf="loading$ | async; else itemsDisplay">
  <em>Loading...</em>
</p>
<ng-template #itemsDisplay>
  <div
    class="flex flex-row justify-start items-start basis-full flex-grow min-h-[400px]"
  >
    <table mat-table [dataSource]="results$">
      <ng-container matColumnDef="item">
        <th mat-header-cell *matHeaderCellDef>Item</th>
        <td mat-cell *matCellDef="let element">
          <a (click)="openItemDialog(element.product_id, element.id)">{{
            element.code
          }}</a>
        </td>
      </ng-container>

      <ng-container matColumnDef="product">
        <th mat-header-cell *matHeaderCellDef>Product</th>
        <td mat-cell *matCellDef="let element">
          <a [routerLink]="['/product', element.product_id]">
            {{ element.name }}
          </a>
        </td>
      </ng-container>

      <ng-container matColumnDef="cost">
        <th mat-header-cell *matHeaderCellDef>
          <div class="flex flex-row items-center justify-start space-x-2">
            <span>Purchase</span>
            <mat-icon [matTooltip]="help.purchase" class="text-gray-300"
              >help
            </mat-icon>
          </div>
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.price | hlCurrency | async }}
          <ng-container *ngIf="element.purchased_at">
            - {{ element.purchased_at | amDateFormat : dateFormat }}
          </ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="maintenance">
        <th mat-header-cell *matHeaderCellDef>
          <div class="flex flex-row items-center justify-start space-x-2">
            <span>Parts</span>
            <mat-icon [matTooltip]="help.parts" class="text-gray-300"
              >help
            </mat-icon>
          </div>
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.parts_cost | hlCurrency | async }}
        </td>
      </ng-container>

      <ng-container matColumnDef="labour_hours">
        <th mat-header-cell *matHeaderCellDef>
          <div class="flex flex-row items-center justify-start space-x-2">
            <span>Labour</span>
            <mat-icon [matTooltip]="help.labour" class="text-gray-300"
              >help
            </mat-icon>
          </div>
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.labour_hours }}
        </td>
      </ng-container>

      <ng-container matColumnDef="labour_cost">
        <th mat-header-cell *matHeaderCellDef>
          <div class="flex flex-row items-center justify-start space-x-2">
            <span>Labour Cost</span>
            <mat-icon [matTooltip]="help.labourCost" class="text-gray-300"
              >help
            </mat-icon>
          </div>
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.labour_cost | hlCurrency | async }}
        </td>
      </ng-container>

      <ng-container matColumnDef="profit">
        <th mat-header-cell *matHeaderCellDef>
          <div class="flex flex-row items-center justify-start space-x-2">
            <span>Profit</span>
            <mat-icon [matTooltip]="help.profit" class="text-gray-300"
              >help
            </mat-icon>
          </div>
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.profit | hlCurrency | async }}
        </td>
      </ng-container>

      <ng-container matColumnDef="revenue">
        <th mat-header-cell *matHeaderCellDef>
          <div class="flex flex-row items-center justify-start space-x-2">
            <span>Revenue</span>
            <mat-icon [matTooltip]="help.revenue" class="text-gray-300"
              >help
            </mat-icon>
          </div>
        </th>
        <td mat-cell *matCellDef="let element">
          <p>{{ element.revenue | hlCurrency | async }}</p>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
</ng-template>
